/* Footer.jsx */

// Imports
import './Footer.css';

// Define consts
const Footer = () => {
    // Return and export
    return (
        <footer className="app-footer" />
    );
};

export default Footer;
